<!-- ScottishPower Business Portal -->
<div class="min-h-screen flex flex-col">
  <app-header></app-header>
  <div class="sticky top-0 z-40">
    <app-broadcast-message></app-broadcast-message>
    @if (!isQuotePage) {
    <app-reward-banner [isQuotePage]="false"></app-reward-banner>
    }
  </div>

  <main class="flex-1">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>

  <!-- Global Error Popup -->
  <app-error-popup></app-error-popup>
</div>